import { TooltipBubble } from '@carboncopyco/ui';
import { CloseIcon } from '../../../../../../assets/svg/CloseIcon';
import { getTabTitle } from '../../../../../util/tab-util';
import { tooltipHackClasses } from '../../../../constants';
import TabIcon from '../TabIcon';
import type { TabProps } from '../types';
import { getTabClasses } from '../utils';

const Tab = ({
  tab,
  activeTabId,
  onClick,
  onClose,
  className,
  style,
  titleAdditionalText,
}: TabProps) => {
  const isActiveTab = tab.id === activeTabId;
  const opacityClasses = `group-hover:opacity-100 ${isActiveTab ? 'opacity-100' : 'opacity-50'}`;

  return (
    <button
      type="button"
      onClick={() => onClick(tab.id)}
      className={`${getTabClasses(isActiveTab)} justify-between w-[200px] ${tooltipHackClasses} ${
        className || ''
      } group`}
      style={style}
      data-testid="global-tab"
    >
      <span
        className={`flex items-center justify-center shrink-0 w-6 h-6 ${opacityClasses}`}
      >
        <TabIcon tab={tab} />
      </span>
      <TooltipBubble
        title={`${getTabTitle(tab)}${titleAdditionalText}`}
        placement="auto-end"
      >
        <span
          className={` whitespace-nowrap overflow-hidden ${opacityClasses}`}
        >
          {getTabTitle(tab)}
          <span className="text-ds-natural-400">{titleAdditionalText}</span>
        </span>
      </TooltipBubble>
      <span className="flex self-stretch relative -ms-1.5 -me-1.5 pointer-events-none">
        <span
          className={`w-4 -ms-4 bg-gradient-to-l rtl:bg-gradient-to-r ${
            isActiveTab
              ? 'from-[var(--ds-tab-active-bg)]'
              : 'from-[var(--ds-tab-inactive-bg)]'
          } group-hover:from-[var(--ds-tab-active-bg)]`}
        />
      </span>

      <span
        className="close-btn opacity-0 group-hover:opacity-100 shrink-0 cursor-pointer [&>svg]:text-current [&>svg]:fill-transparent [&>svg]:transition-[fill]"
        onClick={(e) => {
          e.stopPropagation();
          onClose?.(tab.id);
        }}
        data-testid="global-tab-close"
      >
        <CloseIcon />
      </span>
    </button>
  );
};

export default Tab;
